import { useMutation, useQuery } from '@tanstack/react-query';

import {
  getBranches,
  getClientsStatistic,
  getStatisticServicesDictionary,
  getStatisticStrategiesDictionary,
} from '../../../../api';
import { PageParams } from '../../../../types/pagination';

export const useClientsStatistic = () =>
  useMutation({ mutationKey: ['getClientsStatistic'], mutationFn: (data: PageParams) => getClientsStatistic(data) });

export const useBranchesDictionary = () => useQuery({ queryKey: ['getBranches'], queryFn: () => getBranches() });

export const useStrategiesDictionary = () =>
  useQuery({ queryKey: ['getStatisticStrategiesDictionary'], queryFn: () => getStatisticStrategiesDictionary() });

export const useServicesDictionary = () =>
  useQuery({ queryKey: ['getStatisticServicesDictionary'], queryFn: () => getStatisticServicesDictionary() });
